import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import {Link} from "react-router-dom";
import { Button, CardMedia } from '@mui/material';
import { ButtonBrand, gold } from '../../../getLPTheme';

const logoStyle = {
  width: '50px',
  height: 'auto',
  cursor: 'pointer',
};


function NavbarBack() {
  return (
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'transparent',
          backgroundImage: 'none',
          mt: 0,
        }}
      >
          <Toolbar
            variant="regular"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
              borderRadius: '999px',
              backdropFilter: 'blur(24px)',
              maxHeight: 40,
              border: '1px solid',
              borderColor: 'divider',   
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '-18px',
                px: 0,
              }}
            >
              <Box sx={{display: 'flex',alignItems: 'center', justifyContent: 'center', direction: "row"}}>
                <Box sx={{px:0}}>
                  <MenuItem >
                    <Link to={"/"} style={{ textDecoration: 'none' }}>
                      <CardMedia  component='img' image='https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/landing-carousel/logoWorldWhite.png' sx={{width: 60, height: 50}}/>
                    </Link>
                  </MenuItem>
                </Box>
                <Box sx={{}}>
                  <CardMedia component='img' image='https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/landing-carousel/logoWorldGolfClubWhite.png' sx={{width: 160, height: 55}}/>
                </Box>
                <Box sx={{pl: 2}}>
                  <Link to={"/"} style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{color: gold[500]}}>
                      VOLVER
                    </MenuItem>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Toolbar>
      </AppBar>
  );
}

export default NavbarBack;
